<div class="sidebar-container" [class.collapsed]="collapsed">
  <!-- Logo Section (hidden when logo is in drawer header) -->
  @if (!hideLogoSection) {
    <div class="logo-section">
      <div class="logo-wrapper">
        <div class="logo-circle">
          <img src="/assets/svg/zaklepuj_icon.svg" alt="Zaklepuj" class="logo-icon" />
        </div>
      </div>
      @if (!collapsed) {
        <div class="logo-text-wrapper">
          <span class="logo-text">{{ 'layout.sidebar.brandName' | transloco }}</span>
          <p class="logo-subtitle">{{ 'layout.sidebar.brandSubtitle' | transloco }}</p>
        </div>
      }
    </div>
  }

  <!-- New Academy Button -->
  <!-- <div class="new-academy-section" *ngIf="!collapsed">
    <button pButton
            type="button"
            class="p-button-outlined p-button-sm w-full"
            icon="pi pi-plus"
            [label]="'layout.sidebar.buttons.newAcademy' | transloco"
            (click)="onNewAcademy()"></button>
  </div>
  <div class="new-academy-section collapsed-btn" *ngIf="collapsed">
    <button pButton
            type="button"
            class="p-button-outlined p-button-sm"
            icon="pi pi-plus"
            pTooltip="{{ 'layout.sidebar.buttons.newAcademy' | transloco }}"
            tooltipPosition="right"
            (click)="onNewAcademy()"></button>
  </div> -->

  <!-- Navigation Menu -->
  <nav class="sidebar-nav">
    <div class="nav-container">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menuItems, isRoot: true, depth: 0 }"></ng-container>
    </div>
  </nav>

  <ng-template #menuTpl let-items let-isRoot="isRoot" let-depth="depth">
    @for (item of items; track item) {
     @if (isItemVisible(item)) {
      <!-- Category headers (depth 0 with children) -->
      @if (depth === 0 && item.children?.length && !collapsed) {
      <div class="nav-category-header">
        <button type="button"
                class="nav-category-toggle"
                (click)="toggleCategory(item)">
          <span class="nav-category-label">
            {{ item.label | transloco }}
          </span>
          <i class="pi chevron-icon"
             [ngClass]="{ 'pi-chevron-down': item.expanded, 'pi-chevron-up': !item.expanded }"></i>
        </button>
      </div>
      }

      <!-- Regular menu items -->
      @if (!(depth === 0 && item.children?.length) || collapsed) {
      <div class="nav-item"
           [class.active]="item.active"
           [class.disabled]="item.disabled"
           [class.has-children]="item.children?.length && !collapsed"
           [style.--depth]="collapsed ? 0 : depth">
        <div class="nav-link-wrapper">
          <button type="button"
                  class="nav-link"
                  [attr.pRipple]="item.disabled ? null : ''"
                  pRipple
                  (click)="!item.disabled && onMenuItemClick(item)"
                  [pTooltip]="collapsed ? (item.label | transloco) : ''"
                  tooltipPosition="right"
                  [showDelay]="300"
                  [disabled]="item.disabled">
            @if (item.icon) {
              <i [class]="item.icon + ' nav-icon'"></i>
            }
            @if (!collapsed) {
              <span class="nav-label">{{ item.label | transloco }}</span>
            }
            @if (item.route === '/conversations' && !collapsed) {
              <app-conversations-badge [unreadCount]="sseService.unreadCount()" />
            }
            @if (item.route === '/szukam-noclegu' && !collapsed && requestBoardBadge.count() > 0) {
              <p-badge [value]="requestBoardBadge.count().toString()" severity="info" />
            }
            @if (item.disabled && !collapsed) {
              <span class="nav-badge-coming-soon">
                <i class="pi pi-lock"></i>
                {{ 'layout.sidebar.comingSoon' | transloco }}
              </span>
            }
          </button>
          @if (item.children?.length && !collapsed) {
            <button type="button"
                    class="nav-chevron-btn"
                    (click)="toggleExpand(item, $event)">
              <i class="pi chevron-icon"
                 [ngClass]="{ 'pi-chevron-down': item.expanded, 'pi-chevron-right': !item.expanded }"></i>
            </button>
          }
        </div>
      </div>
      }

      <!-- Children container (hidden when collapsed) -->
      @if (item.children?.length && item.expanded && !collapsed) {
        <div class="nav-children" [@slideDown]>
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: item.children, isRoot: false, depth: depth + 1 }"></ng-container>
        </div>
      }
     }
    }
  </ng-template>

  <!-- Collapse Toggle Button (desktop only) -->
  @if (!isMobile) {
    <div class="collapse-toggle-section">
      <button type="button"
              class="collapse-toggle-btn"
              pRipple
              (click)="onCollapseToggle()">
        <i class="pi" [ngClass]="collapsed ? 'pi-angle-right' : 'pi-angle-left'"></i>
      </button>
    </div>
  }

  <!-- Legal Links (mobile only) -->
  @if (isMobile) {
    <div class="legal-links-section">
      <button type="button" class="legal-link" (click)="onLegalLinkClick('privacy-policy')">
        {{ 'layout.sidebar.legal.privacyPolicy' | transloco }}
      </button>
      <span class="legal-separator">·</span>
      <button type="button" class="legal-link" (click)="onLegalLinkClick('cookies')">
        {{ 'layout.sidebar.legal.cookies' | transloco }}
      </button>
    </div>
  }

  <!-- User Profile Section -->
  <div class="user-profile-container">
    <button type="button"
            class="user-profile"
            pRipple
            (click)="collapsed ? onCollapseToggle() : toggleUserMenu()"
            [pTooltip]="collapsed ? userInfo.name : ''"
            tooltipPosition="right"
            [class.expanded]="userMenuExpanded">
      <div class="user-avatar">
        <p-avatar
          [label]="userInfo.avatar"
          size="large"
          shape="circle"
          styleClass="user-avatar-circle">
        </p-avatar>
      </div>
      @if (!collapsed) {
        <div class="user-info">
          <h4 class="user-name">{{ userInfo.name }}</h4>
          <app-plan-badge class="user-status" [plan]="plan()"></app-plan-badge>
        </div>
        <div class="user-chevron">
          <i class="pi chevron-icon"
             [ngClass]="{ 'pi-chevron-up': userMenuExpanded, 'pi-chevron-down': !userMenuExpanded }"></i>
        </div>
      }
    </button>

    <!-- User menu options (hidden when collapsed) -->
    @if (userMenuExpanded && !collapsed) {
    <div class="user-menu-options" [@slideDown]>
      <!-- <button type="button"
              class="user-menu-item"
              pRipple
              (click)="onUserMenuAction('profile')">
        <i class="pi pi-user"></i>
        <span>{{ 'layout.sidebar.userMenu.profile' | transloco }}</span>
      </button> -->
      @if (isFreePlan()) {
        <button type="button"
                class="user-menu-item upgrade"
                pRipple
                (click)="onUpgrade()">
          <i class="pi pi-bolt"></i>
          <span>{{ 'plans.upgradeCta' | transloco }}</span>
        </button>
      }
      <button type="button"
              class="user-menu-item"
              pRipple
              (click)="onUserMenuAction('settings')">
        <i class="pi pi-cog"></i>
        <span>{{ 'layout.sidebar.userMenu.settings' | transloco }}</span>
      </button>
      <div class="user-menu-language">
        <i class="pi pi-language" aria-hidden="true"></i>
        <span id="sidebar-language-label">{{ 'layout.sidebar.userMenu.language' | transloco }}</span>
        <p-selectbutton
          [options]="languageOptions"
          optionLabel="label"
          optionValue="value"
          [allowEmpty]="false"
          size="small"
          ariaLabelledBy="sidebar-language-label"
          [ngModel]="currentLanguage()"
          (onChange)="onLanguageChange($event.value)" />
      </div>
      <div class="user-menu-divider"></div>
      <button type="button"
              class="user-menu-item logout"
              pRipple
              (click)="onUserMenuAction('logout')">
        <i class="pi pi-sign-out"></i>
        <span>{{ 'layout.sidebar.userMenu.logout' | transloco }}</span>
      </button>
    </div>
    }
  </div>
</div>
